
// Angular Core
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { LayoutModule } from '@angular/cdk/layout'
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatePipe } from '@angular/common';

import { ToastrModule } from 'ngx-toastr';
import { FileUploadModule } from 'ng2-file-upload';
import { SharedModule } from './shared/shared.module';

import { AppRoutingModule } from './app-routing.module';
import { AppConfiguration } from './app-configuration';

import { CustomInterceptor, ErrorInterceptor, JwtInterceptor } from './core/interceptors';
import { ErrortostringPipe } from './core/pipes';
import { ErrorLogService } from './core/services/error-log.service';


//Components
import { AppComponent } from './app.component';
import { HomePageComponent } from './views/pages/home-page/home-page.component';
import { DashboardComponent } from './views/partials/dashboard/dashboard.component';
import { CurrentCertsComponent } from './views/partials/current-certs/current-certs.component';
import { CertWizardComponent } from './views/pages/cert-wizard/cert-wizard.component';
import { FooterComponent } from './views/themes/footer/footer.component';
import { QuestionComponent } from './views/partials/shared/question/question.component';
import { CertWizControllerComponent } from './views/partials/cert-wiz-controller/cert-wiz-controller.component';
import { AppRequiredItemComponent } from './views/partials/application/app-required-item/app-required-item.component';
import { MessageDialogComponent } from './views/partials/shared/message-dialog/message-dialog.component';
import { CertItemComponent } from './views/partials/cert-item/cert-item.component';
import { AppWizardComponent } from './views/pages/app-wiz/app-wiz.component';
import { PersonalDataComponent } from './views/partials/application/form/personal-data/personal-data.component';
import { ProofOfCitizenshipComponent } from './views/partials/application/form/proof-of-citizenship/proof-of-citizenship.component';
import { MilitaryDeclarationComponent } from './views/partials/application/form/military-declaration/military-declaration.component';
import { ProfessionalStatusCriminalHistoryComponent } from './views/partials/application/form/professional-status-criminal-history/professional-status-criminal-history.component';
import { PraxxisAssessmentListComponent } from './views/partials/application/form/praxxis-assessment-list/praxxis-assessment-list.component';
import { FormSectionArtifactComponent } from './views/partials/application/form/form-section-artifact/form-section-artifact.component';
import { AcceptanceSignatureComponent } from './views/partials/application/form/acceptance-signature/acceptance-signature.component';
import { HelpComponent } from './views/pages/help/help.component';
import { MessageCenterComponent } from './views/partials/message-center/message-center.component';
import { BackgroundReviewComponent } from './views/partials/background-review/background-review.component'
import { HeaderComponent } from './views/themes/header/header.component';
import { LayoutComponent } from './views/themes/layout/layout.component';
import { LoginComponent } from './views/pages/public/login/login.component';
import { QuestionWizardComponent } from './views/partials/shared/question-wizard/question-wizard.component';
import { FileUploadComponent } from './views/partials/shared/file-upload/file-upload.component';
import { BtnActionComponent } from './views/partials/shared/btn-action/btn-action.component';
import { PaymentComponent } from './views/partials/payment/payment.component';
import { StandalonePaymentComponent } from './views/partials/standalone-payment/standalone-payment.component';
import { StandalonePaymentConfirmationComponent } from './views/partials/standalone-payment/standalone-payment-confirmation.component';
import { EducationRecordComponent } from './views/partials/application/form/education-record/education-record.component';
import { EducationalExperienceComponent } from './views/partials/application/form/educational-experience/educational-experience.component';
import { PaymentErrorComponent } from './views/partials/payment-error/payment-error.component';
import { SupportComponent } from './views/pages/support/support.component';
import { ArtifactActionComponent } from './views/partials/application/artifact-action/artifact-action.component';
import { MoreInformationNeededComponent } from './views/partials/application/form/more-information-needed/more-information-needed.component';
import { BannerComponent } from './views/partials/shared/banner/banner.component';
import { EducationRecordSubstituteComponent } from './views/partials/application/form/education-record-substitute/education-record-substitute.component';
import { ClassInfoAaComponent } from './views/partials/application/form/class-info-aa/class-info-aa.component';
import { ClassInfoBComponent } from './views/partials/application/form/class-info-b/class-info-b.component';
import { ClassInfoAAlternativeComponent } from './views/partials/application/form/class-info-a-alternative/class-info-a-alternative.component';
import { ClassInfoATraditionalComponent } from './views/partials/application/form/class-info-a-traditional/class-info-a-traditional.component';
import { InternshipPlacementComponent } from './views/partials/application/form/internship-placement/internship-placement.component';
import { AlsdePersonComponent } from './views/partials/application/form/alsde-person/alsde-person.component';
import { CertPersonLookupComponent } from './views/partials/application/form/cert-person-lookup/cert-person-lookup.component';
import { SchoolPlacementComponent } from './views/partials/application/form/school-placement/school-placement.component';
import { SchoolSystemSelectionComponent } from './views/partials/application/form/school-system-selection/school-system-selection.component';
import { TeamsContractDetailsComponent } from './views/partials/application/form/teams-contract-details/teams-contract-details.component';
import { EducationRecordHsComponent } from './views/partials/application/form/education-record-hs/education-record-hs.component';
import { EducationRecordTeComponent } from './views/partials/application/form/education-record-te/education-record-te.component';
import { ViewCertDialogComponent } from './views/partials/shared/dialogs/view-cert-dialog/view-cert-dialog.component';
import { EligibilityRulesDialogComponent } from './views/partials/shared/dialogs/eligibility-rules-dialog/eligibility-rules-dialog.component';
import { RequestApplicantResubmitComponent } from './views/partials/shared/dialogs/request-applicant-resubmit-dialog/request-applicant-resubmit-dialog.component';
import { TranscriptComponent } from './views/partials/application/form/transcript/transcript.component';
import { AppfeeComponent } from './views/partials/application/form/appfee/appfee.component';
import { FormDownloadComponent } from './views/partials/application/form/form-download/form-download.component';
import { FileUploadFormComponent } from './views/partials/application/form/file-upload-form/file-upload-form.component';
import { BgrFormComponent } from './views/partials/application/form/bgr-form/bgr-form.component';
import { MobileViewDialogComponent } from './views/partials/shared/dialogs/mobile-view-dialog/mobile-view-dialog.component';
import { AppWizardHeaderComponent } from './views/partials/app-wizard-header/app-wizard-header.component';
import { AppWizardPercentComponent } from './views/partials/app-wizard-percent/app-wizard-percent.component';
import { RcrCourseworkComponent } from './views/partials/application/form/rcr-coursework/rcr-coursework.component';
import { VerifyProfDevelopmentComponent } from './views/partials/application/form/verify-prof-development/verify-prof-development.component';
import { PowerSchoolAttestationComponent } from './views/partials/application/form/power-school-attestation/power-school-attestation.component';
import { NonRenewalComponent } from './views/partials/application/form/non-renewal/non-renewal.component';
import { DenyApplicationComponent } from './views/partials/shared/dialogs/deny-application-dialog/deny-application-dialog.component';
import { OlrCeOptionComponent } from './views/partials/application/form/olr-ce-option/olr-ce-option.component';
import { AppNotesComponent } from './views/partials/application/app-notes/app-notes.component';
import { AcceptanceSubmittedThankyouComponent } from './views/partials/shared/dialogs/acceptance-submitted-thankyou/acceptance-submitted-thankyou.component';
import { LoginTermAndConditionComponent } from './views/partials/shared/dialogs/login-term-and-condition/login-term-and-condition.component';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { AppProgressDialogComponent } from './views/partials/shared/dialogs/app-progress-dialog/app-progress-dialog.component';

import packageJson from '../../package.json';
import { AppConfigService, initializeApp } from './core/services/app-config.service';
import { AcknowledgeComponent } from './views/partials/application/form/acknowledge/acknowledge.component';
import { DocumentReviewComponent } from './views/partials/application/form/document-review/document-review.component';
import { PdfSummaryComponent } from './views/pages/pdf-summary/pdf-summary.component';
import { AttestationComponent } from './views/partials/application/form/attestation/attestation.component';
import { DeleteApplicationDialogComponent } from './views/partials/shared/dialogs/delete-application-dialog/delete-application-dialog.component';
@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    DashboardComponent,
    CurrentCertsComponent,
    CertWizardComponent,
    HeaderComponent,
    FooterComponent,
    QuestionComponent,
    CertWizControllerComponent,
    AppRequiredItemComponent,
    MessageDialogComponent,
    ViewCertDialogComponent,
    EligibilityRulesDialogComponent,
    RequestApplicantResubmitComponent,
    DenyApplicationComponent,
    CertItemComponent,
    AppWizardComponent,
    PersonalDataComponent,
    ProofOfCitizenshipComponent,
    MilitaryDeclarationComponent,
    ProfessionalStatusCriminalHistoryComponent,
    PraxxisAssessmentListComponent,
    FormSectionArtifactComponent,
    AcceptanceSignatureComponent,
    HelpComponent,
    MessageCenterComponent,
    BackgroundReviewComponent,
    LayoutComponent,
    LoginComponent,
    QuestionWizardComponent,
    FileUploadComponent,
    BtnActionComponent,
    PaymentComponent,
    StandalonePaymentComponent,
    StandalonePaymentConfirmationComponent,
    EducationRecordComponent,
    SchoolPlacementComponent,
    SchoolSystemSelectionComponent,
    EducationalExperienceComponent,
    PaymentErrorComponent,
    SupportComponent,
    ArtifactActionComponent,
    MoreInformationNeededComponent,
    TranscriptComponent,
    AppfeeComponent,
    FormDownloadComponent,
    FileUploadFormComponent,
    BgrFormComponent,
    BannerComponent,
    ErrortostringPipe,
    EducationRecordSubstituteComponent,
    EducationRecordTeComponent,
    EducationRecordHsComponent,
    ClassInfoAaComponent,
    ClassInfoBComponent,
    ClassInfoAAlternativeComponent,
    ClassInfoATraditionalComponent,
    InternshipPlacementComponent,
    AlsdePersonComponent,
    CertPersonLookupComponent,
    TeamsContractDetailsComponent,
    MobileViewDialogComponent,
    AppWizardHeaderComponent,
    AppWizardPercentComponent,
    RcrCourseworkComponent,
    VerifyProfDevelopmentComponent,
    PowerSchoolAttestationComponent,
    NonRenewalComponent,
    OlrCeOptionComponent,
    AppNotesComponent,
    AcceptanceSubmittedThankyouComponent,
    LoginTermAndConditionComponent,
    AppProgressDialogComponent,
    AcknowledgeComponent,
    DocumentReviewComponent,
    PdfSummaryComponent,
    AttestationComponent,
    DeleteApplicationDialogComponent,
  ],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    HttpClientModule,
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
  ],
  entryComponents: [
    MessageDialogComponent,
    ViewCertDialogComponent,
    EligibilityRulesDialogComponent,
    RequestApplicantResubmitComponent,
    MobileViewDialogComponent,
    DenyApplicationComponent,
    AppProgressDialogComponent,
    DeleteApplicationDialogComponent,
  ],
  providers: [
    AppConfiguration,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true },
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true } },
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false } },
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { position: 'above' } },
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppConfigService], multi: true }
    // { provide: ErrorHandler, useExisting : ErrorLogService}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    console.log("ACE version: " + packageJson.version);
  }
}
